import { extractPageType } from '@utils/cook'
import { FunctionComponent, ReactElement } from 'react'
import { useQueryClient } from 'react-query'

interface QueryClientConsumerProps {
  children: ({
    isArticle,
    isRecipe,
  }: {
    isArticle: boolean
    isRecipe: boolean
  }) => ReactElement<any, any> | null
}

const QueryClientConsumer: FunctionComponent<QueryClientConsumerProps> = ({
  children,
}) => {
  const queryClient = useQueryClient()
  const pageData = queryClient.getQueryData<any>('page')
  const isRecipe = pageData?.metadata?.teaser?.targetContentType === 'recipe'
  const isArticle = extractPageType(pageData?.metadata) === 'article'

  return children({ isArticle, isRecipe })
}

export default QueryClientConsumer
